<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  setException,
  removeDetail,
} from "@/api/finance/segmentBill";
import cTable from "@/base/common/index";
import { getCountry } from "@/api/system/country";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";
export default {
  name: "dduShipment",
  components: {
    cTable,
  },
  props: {
    row: {
      type: Object,
    },
    tabName: String,
  },
  data() {
    return {
      methods: {
        list: (params) => {
          params.id = this.row.id;
          params.dataType = this.tabName;
          return getDetails(params);
        },
        setException,
        removeDetail,
      },
      footer: {},
      config: {
        tabName: this.tabName,
        rows: this.row,
        slot: "div",
        height: 630,
        contentMethod({ row, column }) {
          if (column.type == "calculate_status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        },
      },
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              data.dataType = this.$page.config.tabName;
              this.$page
                .handleRequestMethods("setException", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            async export({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  ...searchForm,
                  page: 1,
                  export: 1,
                  dataType: this.config.tabName,
                },
                false,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload.src);
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                    dataType: this.config.tabName,
                  };
                  this.handleRequestMethods("removeDetail", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$tz("出货日期"),
          key: "outbound_time",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户名称"),
          key: "clientInfo.client_account",
          minWidth: 120,
        },
        {
          name: () => this.$tz("出货单号"),
          key: "airway_bill_number",
          minWidth: 120,
        },
        {
          name: () => this.$tz("原单号"),
          key: "client_refer_code",
          minWidth: 120,
        },
        {
          name: () => this.$tz("起运国家"),
          key: "from_country",
          minWidth: 120,
        },
        {
          name: () => this.$tz("目的国家"),
          key: "to_country",
          minWidth: 120,
        },
        {
          name: () => this.$tz("目的地"),
          key: "shipment.city_name",
          minWidth: 120,
        },
        {
          name: () => this.$tz("实际重量"),
          key: "shipment.check_weight",
          minWidth: 120,
        },
        {
          name: () => this.$tz("计费重量"),
          key: "charge_params",
          minWidth: 120,
        },
        {
          name: () => this.$tz("申报价值"),
          key: "shipment.values",
          minWidth: 100,
        },
        {
          name: () => this.$tz("费用"),
          children: [
            {
              name: () => this.$tz("币种"),
              key: "financeFeesInfo.currency",
              minWidth: 110,
            },
            {
              name: () => this.$tz("头程费用"),
              key: "financeFeesInfo.first_charge_fee",
              minWidth: 100,
            },
            {
              name: () => this.$tz("清关,费用"),
              key: "financeFeesInfo.customs_clearance_fee",
              minWidth: 110,
            },
            {
              name: () => this.$tz("其他费用"),
              key: "financeFeesInfo.other_fee",
              minWidth: 100,
            },
            {
              name: () => this.$tz("合计,应收金额"),
              key: "financeFeesInfo.total",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$tz("COD,金额"),
          key: "shipment.cod_amount",
          minWidth: 120,
        },
        {
          name: () => this.$tz("COD,币种"),
          key: "to_country_currency",
          minWidth: 120,
        },
        {
          name: () => this.$t("bill_type"),
          key: "finance_status_txt",
          width: 80,
          methods: {
            render({ row }) {
              return row.finance_status_txt;
            },
          },
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          width: 110,
          noDeep: true,
        },
        {
          name: () => this.$tz("账单名称"),
          key: "quotation_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("exlType"),
          key: "calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          fixed: "right",
          bind: {
            style({ row }) {
              return {
                color: row.calculate_status == 1 ? "#4caf50" : "#f44336",
              };
            },
          },
          methods: {
            render: ({ row }) => {
              return row.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            },
          },
        },
      ],
    };
  },
  async mounted() {
    let fromCountry = (
      await getCountry({
        allow_depart: 1,
      })
    ).data.payload.rows;
    let toCountry = (
      await getCountry({
        allow_arrive: 1,
      })
    ).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    let salesman = (
      await getUser({
        standard: "Salesman",
      })
    ).data.payload.rows;
    let companiesList = (await getCompanies()).data.payload;
    let agent = (await getAgent()).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "client_id") item.options = client;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "ownership") item.options = companiesList;
      if (item.key === "deliver") item.options = agent;
    });
  },
};
</script>
